var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgUnlockmessage = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 115,
  height: 105,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M23.438 56.483c-1.023 2.924-1.333 6.088-1.333 9.256 0 18.14 14.705 32.846 32.845 32.846h16.33c1.8 0 3.56-.153 5.275-.431l9.327 4.633c3.104 1.542 6.677-.988 6.254-4.428l-.811-6.6c7.783-6.005 12.801-15.425 12.801-26.02 0-17.835-14.215-32.35-31.934-32.832l-.025-.001h-.025l-17.204.389c-14.956.005-26.967 10.243-31.5 23.188Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__a)",
  d: "M54.95 34.295c-14.477 0-26.154 9.912-30.568 22.518-.972 2.776-1.277 5.816-1.277 8.926 0 17.588 14.257 31.846 31.845 31.846h16.33c1.853 0 3.665-.167 5.43-.471l9.617 4.777c2.39 1.188 5.142-.761 4.817-3.41l-.882-7.172c7.806-5.803 12.864-15.095 12.864-25.57 0-17.292-13.782-31.364-30.961-31.833l-17.215.389Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__b)",
  d: "m90.262 91.308.88 7.171c.327 2.651-2.425 4.599-4.815 3.411l-9.617-4.776a32.08 32.08 0 0 1-5.43.47h-6.134L24.376 56.81l-.005.01c3.773-12.615 16.087-22.527 30.578-22.527l17.215-.389c8.443.23 16.065 3.746 21.635 9.315 5.762 5.764 9.326 13.725 9.326 22.518 0 10.475-5.058 19.768-12.863 25.57Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__c)",
  d: "M100.95 77.32H25.275c4.633 11.86 16.172 20.264 29.674 20.264h16.33c1.853 0 3.665-.167 5.43-.47l9.617 4.777c2.39 1.187 5.142-.761 4.816-3.41l-.881-7.172a31.945 31.945 0 0 0 10.689-13.99Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__d)",
  d: "M29.442 0h14.65c15.777 0 28.567 12.79 28.567 28.567 0 1.825-.17 3.61-.498 5.34-2.5 13.225-14.117 23.027-28.069 23.027h-14.65c-1.661 0-3.287.05-4.87-.222l-8.627 4.285c-2.145 1.066-4.614-.682-4.321-3.059l.79-6.433C5.413 46.3.876 37.964.876 28.567.875 12.79 13.665 0 29.442 0Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__e)",
  d: "M2.506 38.093a28.638 28.638 0 0 0 9.91 13.413l-.791 6.433c-.292 2.377 2.176 4.124 4.32 3.06l8.628-4.286c1.583.272 3.209.221 4.87.221h14.65c12.437 0 22.816-7.748 26.738-18.841H2.506Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M71.178 33.72c-2.41 12.752-13.613 22.214-27.086 22.214h-14.65c-.234 0-.464 0-.69.002-1.433.005-2.736.01-4.011-.21l-.322-.055-.292.146-8.627 4.285.445.895-.445-.895c-1.432.71-3.079-.456-2.884-2.042l.791-6.433.071-.577-.467-.347C6.252 45.677 1.875 37.633 1.875 28.567 1.875 13.342 14.217 1 29.442 1h14.65c15.225 0 27.567 12.342 27.567 27.567 0 1.762-.165 3.485-.48 5.154Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__f)",
  d: "M52.323 31.246a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__g)",
  d: "M36.769 31.246a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__h)",
  d: "M21.215 31.246a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__i)",
  d: "M78.668 73.023a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__j)",
  d: "M63.114 73.023a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__k)",
  d: "M47.56 73.022a5.582 5.582 0 1 0 0-11.165 5.582 5.582 0 0 0 0 11.165Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__l)",
  d: "M72.159 33.909a32.314 32.314 0 0 0-.882-.013H54.946c-14.488 0-26.715 9.676-30.575 22.918l.2-.1c1.584.272 3.21.422 4.871.422h14.65c13.952 0 25.566-10.003 28.067-23.227Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__m)",
  d: "M106.224 17.5v3.616c0 .56-1.15 1.013-2.569 1.013-1.418 0-2.568-.453-2.568-1.013V17.5c0-5.183-4.217-9.399-9.4-9.399-5.183 0-9.4 4.216-9.4 9.4v13.062c0 .56-1.15 1.012-2.568 1.012-1.42 0-2.569-.453-2.569-1.012V17.5c0-8.016 6.521-14.536 14.537-14.536 8.016 0 14.537 6.52 14.537 14.536Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M76.15 17.5v13.063c0 .509.266.888.52 1.125.253.236.565.402.866.521.608.24 1.38.366 2.183.366.802 0 1.574-.126 2.183-.366a2.74 2.74 0 0 0 .865-.52c.255-.237.52-.617.52-1.126V17.5c0-4.63 3.77-8.399 8.4-8.399 4.63 0 8.4 3.768 8.4 8.4v3.615c0 .51.266.89.52 1.126.253.236.564.402.866.52.608.24 1.38.367 2.182.367.803 0 1.575-.127 2.183-.366.302-.12.613-.285.866-.521.254-.237.52-.617.52-1.126V17.5c0-8.568-6.969-15.536-15.537-15.536-8.568 0-15.537 6.968-15.537 15.536Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__n)",
  d: "M91.688 2.964c-.208 0-.414.005-.619.014v5.145c.205-.013.41-.022.618-.022 5.183 0 9.4 4.216 9.4 9.4v3.615c0 .56 1.151 1.013 2.569 1.013 1.419 0 2.568-.453 2.568-1.013V17.5c0-8.016-6.52-14.536-14.537-14.536Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__o)",
  d: "M79.72 31.575c1.418 0 2.568-.453 2.568-1.012V17.5c0-.412.03-.816.081-1.213h-5.167c-.033.4-.05.804-.05 1.213v13.062c0 .56 1.149 1.012 2.568 1.012Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__p)",
  d: "M101.088 17.5v3.616c0 .56 1.15 1.013 2.568 1.013 1.419 0 2.569-.453 2.569-1.013v-3.615c0-.409-.018-.813-.051-1.213h-5.167c.051.397.081.801.081 1.213Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__q)",
  d: "M108.607 63.187a89.139 89.139 0 0 1-33.84 0c-1.396-.268-2.524-1.493-2.887-3.113-2.175-9.706-2.175-19.465 0-29.172.363-1.62 1.491-2.845 2.887-3.113a89.143 89.143 0 0 1 33.84 0c1.396.268 2.524 1.492 2.887 3.113 2.175 9.707 2.175 19.466 0 29.172-.363 1.62-1.491 2.845-2.887 3.113Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__r)",
  d: "M90.311 46.458H70.257a66.674 66.674 0 0 0 1.623 13.616c.363 1.62 1.492 2.845 2.887 3.113a89.746 89.746 0 0 0 15.544 1.608V46.458Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__s)",
  d: "M90.311 46.458H70.257a66.674 66.674 0 0 0 1.623 13.616c.363 1.62 1.492 2.845 2.887 3.113a89.746 89.746 0 0 0 15.544 1.608V46.458Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__t)",
  d: "M111.494 30.902c-.363-1.62-1.491-2.845-2.887-3.113a89.345 89.345 0 0 0-20.113-1.563c4.581.166 9.16.687 13.727 1.563 1.396.268 2.524 1.492 2.887 3.113 2.175 9.707 2.175 19.465 0 29.172-.363 1.62-1.491 2.845-2.887 3.113a89.955 89.955 0 0 1-13.727 1.562 89.343 89.343 0 0 0 20.113-1.562c1.396-.268 2.524-1.493 2.887-3.113 2.175-9.706 2.175-19.465 0-29.172Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__u)",
  d: "M108.607 27.79a90.828 90.828 0 0 0-7.115-1.076v.94c.243.044.486.089.729.136 1.396.267 2.524 1.492 2.887 3.112 2.175 9.707 2.175 19.466 0 29.172-.363 1.62-1.491 2.845-2.887 3.113-.243.046-.486.092-.729.136v.939a90.923 90.923 0 0 0 7.115-1.075c1.396-.268 2.524-1.492 2.887-3.113 2.175-9.706 2.175-19.465 0-29.172-.363-1.62-1.491-2.845-2.887-3.113Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__v)",
  d: "M71.88 60.074c.363 1.62 1.491 2.845 2.887 3.112a89.139 89.139 0 0 0 33.84 0c1.396-.267 2.524-1.492 2.887-3.112a66.577 66.577 0 0 0 1.631-14.586H70.249c0 4.866.544 9.733 1.631 14.586Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M76.895 27.407c-.71.119-1.419.246-2.128.382-1.396.268-2.524 1.492-2.887 3.113l-1.255 6.562m11.771-10.646c8.638-.88 17.592-.683 26.211.971 1.395.268 2.524 1.492 2.887 3.113 2.175 9.707 2.174 19.466 0 29.172-.363 1.62-1.491 2.845-2.887 3.113-1.91.366-3.821.67-5.734.913"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__w)",
  d: "M88.495 57.33a4.113 4.113 0 0 1-4.109-4.108V49.26c0-.859-.375-1.66-1.029-2.198a8.041 8.041 0 0 1-2.95-6.54 8.04 8.04 0 0 1 2.464-5.517 8.053 8.053 0 0 1 5.593-2.288h.03c4.463 0 8.094 3.63 8.094 8.093a8.067 8.067 0 0 1-2.955 6.252 2.832 2.832 0 0 0-1.03 2.198v3.962a4.113 4.113 0 0 1-4.108 4.108Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__x)",
  d: "M94.843 40.81a6.348 6.348 0 0 0-6.373-6.348c-3.386.013-6.202 2.737-6.32 6.122a6.333 6.333 0 0 0 2.315 5.13 4.587 4.587 0 0 1 1.666 3.546v3.962a2.363 2.363 0 0 0 4.727 0v-3.878l-.241-.084c0-1.371.486-2.796 1.545-3.667 1.18-.97 2.608-3.817 2.608-3.817.044-.316.073-.637.073-.966Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__y)",
  d: "M94.843 40.81a6.348 6.348 0 0 0-6.373-6.348c-3.386.013-6.202 2.737-6.32 6.122a6.333 6.333 0 0 0 2.315 5.13 4.587 4.587 0 0 1 1.666 3.546v3.962a2.363 2.363 0 0 0 4.727 0v-3.878l-.241-.084c0-1.371.486-2.796 1.545-3.667 1.18-.97 2.608-3.817 2.608-3.817.044-.316.073-.637.073-.966Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__z)",
  d: "M94.843 40.81a6.348 6.348 0 0 0-6.373-6.348c-3.386.013-6.202 2.737-6.32 6.122a6.333 6.333 0 0 0 2.315 5.13 4.587 4.587 0 0 1 1.666 3.546v3.962a2.363 2.363 0 0 0 4.727 0v-3.878l-.241-.084c0-1.371.486-2.796 1.545-3.667 1.18-.97 2.608-3.817 2.608-3.817.044-.316.073-.637.073-.966Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__A)",
  d: "M86.099 48.714c.021.18.033.363.033.546v3.962a2.363 2.363 0 1 0 4.726 0v-3.878l-.241-.084c0-.182.009-.364.026-.546h-4.544Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__B)",
  d: "M86.099 48.714c.021.18.033.363.033.546v3.962a2.363 2.363 0 1 0 4.726 0v-3.878l-.241-.084c0-.182.009-.364.026-.546h-4.544Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__C)",
  d: "M59.883 47.619a2.595 2.595 0 1 1 0-5.19 2.595 2.595 0 0 1 0 5.19Zm18.294-5.843a5.85 5.85 0 0 1-4.86-2.584 10.471 10.471 0 0 0-8.668-4.65c-5.675-.022-10.388 4.556-10.521 10.23-.139 5.903 4.606 10.733 10.48 10.733 3.304 0 6.251-1.53 8.172-3.92 1.128-1.402 2.813-2.24 4.613-2.24h13.464v-.085c0-1.371.608-2.676 1.667-3.546a6.336 6.336 0 0 0 2.245-3.938H78.177Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__D)",
  d: "M67.897 49.697c-.88 0-1.592-.713-1.592-1.593v-6.162a1.592 1.592 0 1 1 3.184 0v6.162c0 .88-.713 1.593-1.592 1.593Z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__E)",
  d: "M62.397 44.394a2.595 2.595 0 1 1-5.03 0h-3.22c-.008.125-.016.25-.019.377-.139 5.904 4.606 10.733 10.48 10.733 3.304 0 6.251-1.529 8.172-3.92 1.128-1.402 2.813-2.24 4.613-2.24h13.464v-.084c0-1.371.608-2.676 1.667-3.547.462-.38.869-.824 1.208-1.319H62.397Z"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__F)",
  d: "M59.883 41.333a3.691 3.691 0 1 0 0 7.382 3.691 3.691 0 0 0 0-7.382Zm0 5.73a2.039 2.039 0 1 1-.001-4.077 2.039 2.039 0 0 1 0 4.077Z"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__G)",
  d: "M77.669 43.3a1.094 1.094 0 1 0 0 2.188h15.114a6.362 6.362 0 0 0 1.55-2.187H77.67Z"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__H)",
  d: "M81.186 46.05a.785.785 0 0 0 0 1.569h9.974a4.569 4.569 0 0 1 1-1.57H81.185Z"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#unlockmessage_svg__I)",
  d: "M82.147 49.344h8.71v-.084c0-1.371.608-2.676 1.667-3.546a6.336 6.336 0 0 0 2.246-3.938H82.147v7.568Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__a",
  x1: 63.115,
  x2: 63.115,
  y1: 44.518,
  y2: 86.741,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA2AF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A636FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__b",
  x1: 84.215,
  x2: 43.938,
  y1: 75.15,
  y2: 34.873,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5A11FE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5B0EFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__c",
  x1: 63.113,
  x2: 63.113,
  y1: 81.473,
  y2: 98.096,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__d",
  x1: 19.04,
  x2: 61.669,
  y1: 3.004,
  y2: 70.85,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#988FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.833,
  stopColor: "#5548F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__e",
  x1: 36.668,
  x2: 36.668,
  y1: 40.632,
  y2: 57.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4071F7",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#30569F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__f",
  x1: 55.408,
  x2: 47.483,
  y1: 22.578,
  y2: 30.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__g",
  x1: 39.855,
  x2: 31.93,
  y1: 22.578,
  y2: 30.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__h",
  x1: 24.301,
  x2: 16.376,
  y1: 22.578,
  y2: 30.503,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__i",
  x1: 81.754,
  x2: 73.829,
  y1: 64.355,
  y2: 72.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__j",
  x1: 66.199,
  x2: 58.274,
  y1: 64.355,
  y2: 72.28,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__k",
  x1: 50.645,
  x2: 42.721,
  y1: 64.355,
  y2: 72.279,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEF4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CFE7FD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__l",
  x1: 48.265,
  x2: 48.265,
  y1: 39.564,
  y2: 60.476,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#AA76D5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#511E93"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__m",
  x1: 82.16,
  x2: 87.999,
  y1: 6.004,
  y2: 15.871,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DFABFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C058FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__n",
  x1: 98.339,
  x2: 106.2,
  y1: 12.546,
  y2: 12.546,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__o",
  x1: 79.76,
  x2: 79.76,
  y1: 24.169,
  y2: 31.767,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__p",
  x1: 103.616,
  x2: 103.616,
  y1: 19.299,
  y2: 22.202,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__q",
  x1: 82.946,
  x2: 100.389,
  y1: 30.938,
  y2: 59.972,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBC56D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__r",
  x1: 82.9,
  x2: 76.356,
  y1: 55.848,
  y2: 47.926,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__s",
  x1: 80.284,
  x2: 80.284,
  y1: 52.084,
  y2: 49.129,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__t",
  x1: 70.216,
  x2: 123.878,
  y1: 19.061,
  y2: 69.929,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__u",
  x1: 107.412,
  x2: 112.337,
  y1: 45.488,
  y2: 45.488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__v",
  x1: 91.687,
  x2: 91.687,
  y1: 53.778,
  y2: 65.059,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__w",
  x1: 86.231,
  x2: 78.188,
  y1: 43.376,
  y2: 38.649,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DC8758",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#DD8654",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E28448",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#EA8034",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#F47B18",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE7701"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__x",
  x1: 84.465,
  x2: 92.223,
  y1: 45.024,
  y2: 45.024,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#4038A4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272265"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__y",
  x1: 86.492,
  x2: 81.694,
  y1: 45.024,
  y2: 45.024,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272265",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1A1A1A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__z",
  x1: 87.674,
  x2: 84.101,
  y1: 41.907,
  y2: 36.138,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5E51EC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E51EC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__A",
  x1: 88.257,
  x2: 86.103,
  y1: 52.15,
  y2: 52.15,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#272265",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#272265"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__B",
  x1: 88.478,
  x2: 88.478,
  y1: 52.586,
  y2: 49.257,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5E51EC",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5E51EC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__C",
  x1: 64.271,
  x2: 80.558,
  y1: 35.394,
  y2: 51.681,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FBE1FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E37FC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__D",
  x1: 69.405,
  x2: 66.286,
  y1: 45.023,
  y2: 45.023,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E37FC9",
  stopOpacity: 0.26
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF8FC5"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__E",
  x1: 74.446,
  x2: 75.882,
  y1: 47.644,
  y2: 54.188,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E37FC9",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#E37FC9",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E37FC9",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#E37FC9",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#E37FC9",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E37FC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__F",
  x1: 62.16,
  x2: 57.444,
  y1: 47.302,
  y2: 42.586,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8A6E2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E37FC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__G",
  x1: 85.454,
  x2: 85.454,
  y1: 45.367,
  y2: 43.345,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC9BE3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E37FC9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__H",
  x1: 86.28,
  x2: 86.28,
  y1: 47.606,
  y2: 46.281,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FC9BE3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED6FCC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "unlockmessage_svg__I",
  x1: 87.288,
  x2: 92.225,
  y1: 44.866,
  y2: 47.794,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E3569A",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.215,
  stopColor: "#E3569A",
  stopOpacity: 0.215
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.429,
  stopColor: "#E3569A",
  stopOpacity: 0.429
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.642,
  stopColor: "#E3569A",
  stopOpacity: 0.642
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.854,
  stopColor: "#E3569A",
  stopOpacity: 0.854
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E3569A"
})))));
export { SvgUnlockmessage as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTBmOTM1ZmE2ZTljYTVhNjFkM2RmNDUzN2FhNTQ2OWQuc3ZnIjs=";